import React from "react"
import { Layout } from "../components/Layout/Layout"
import { graphql } from "gatsby"
import { EversportsWidget } from "../components/EversportsWidget"
import { EVERSPORTS_IDS } from "../config/eversportsWidgets"
import { PageTitle } from "../components/PageTitle/PageTitle"

interface CouponsProps {
  data: {
    cms: {
      page: {
        title: string
      }
    }
  }
}

export const Coupons: React.FC<CouponsProps> = ({ data }) => {
  return (
    <Layout withPadding>
      <div className="flex flex-col items-center sm:w-11/12 lg:w-full">
        <PageTitle>{data.cms.page.title}</PageTitle>
        {/*
          Eversports Widget — Vouchers / Gutscheine
          OLD widget ID/URL: t4ez9i?list=voucher → https://www.eversports.de/widget/w/t4ez9i?list=voucher
          NEW widget ID: TODO — fill in from Eversports Manager > Settings > Widgets [NEW]
          Page: /coupons
        */}
        <EversportsWidget
          widgetId={EVERSPORTS_IDS.VOUCHERS}
          label="coupons from eversports"
          className="mx-16 w-full bg-white px-8 py-4 lg:w-10/12"
        />
      </div>
    </Layout>
  )
}
export default Coupons
export const query = graphql`
  {
    cms {
      page(id: "/coupons", idType: URI) {
        title
      }
    }
  }
`
